import { render } from "./RankingIcon.vue?vue&type=template&id=588a9c52"
import script from "./RankingIcon.vue?vue&type=script&lang=js"
export * from "./RankingIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__